export const HeaderBgStyles = Object.freeze({
  SMALL: 'small',
} as const);
